import { Get, getAPIUrl } from "../../apiMethods";

export const DashboardEndpoint = {
  dashStats: "restaurant/dashboard/dashboardStats",
  salesGraph: "restaurant/dashboard/sales-graph",
  paymentMethods:"restaurant/dashboard/sales-report",
  notifications:"restaurant/order/order-notification"
};

export const getDashStats = (param = "") => {
  const url = getAPIUrl(DashboardEndpoint.dashStats, param);
  return Get(url);
};

export const getSaleGraph = (param = "") => {
  const url = getAPIUrl(DashboardEndpoint.salesGraph, param);
  return Get(url);
};

export const getPaymentGraph = (param = "") => {
  const url = getAPIUrl(DashboardEndpoint.paymentMethods, param);
  return Get(url);
};

export const getNotifications = (param = "") => {
  const url = getAPIUrl(DashboardEndpoint.notifications, param);
  return Get(url);
};